module.exports = __webpack_public_path__ + "static/media/action-icon-buttons-outlined-32-gold-right-arrow.e391e5a3.svg";